import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useState, JSX } from 'react';
import {
  useCommonContext,
  usePurchaseHistoryContext,
} from '../../../hooks/useContexts';
import { IAlert } from '../../../models/common';
import { IPHRequest } from '../../../models/purchase-history';
import {
  AddReceiptButton,
  BuildertrendButton,
  ExportButton,
  PrintButton,
  QuickBooksButton,
} from './index';

const renderBuilderTrendButton = (customerType: string) => {
  if (customerType === 'b2b') {
    return (
      <div style={{ padding: 15 }}>
        <BuildertrendButton />
      </div>
    );
  }
  return null;
};

const renderQuickBooksButton = (
  customerType: string,
  request: IPHRequest,
  setAlertState: (value: IAlert | null) => void,
  orderLength: number,
  orderHistoryLoaded: boolean,
) => {
  if (customerType === 'b2b' && orderLength > 0 && orderHistoryLoaded) {
    return (
      <div style={{ padding: 15 }}>
        <QuickBooksButton request={request} setAlertState={setAlertState} />
      </div>
    );
  }
  return null;
};

export const OrderHistoryHeader = (): JSX.Element | null => {
  const { svocID } = useThdCustomer();
  const { isDesktop } = useCommonContext();
  const {
    setAlertState,
    orderHistoryData,
    orderHistoryLoaded,
    pHRequest,
    customerType,
  } = usePurchaseHistoryContext();

  const [renderBTBtn, setRenderBTBtn] = useState(false);

  const totalNumberOfOrders =
    orderHistoryData?.orderCount || orderHistoryData?.itemsCount || 0;

  // TODO: temp solution to prevent buttons from rendering before the page is fully loaded
  // Reason: buildertrend button taking on style from add receipt button
  setTimeout(() => {
    setRenderBTBtn(true);
  }, 1000);

  return (
    <div
      className="no-print sui-flex sui-justify-end sui-items-center sui-h-full"
      data-testid="purchase-history-page-layout-header"
    >
      {isDesktop && renderBTBtn && renderBuilderTrendButton(customerType)}
      {isDesktop &&
        renderQuickBooksButton(
          customerType,
          pHRequest,
          setAlertState,
          totalNumberOfOrders,
          orderHistoryLoaded,
        )}
      {isDesktop &&
        customerType === 'b2b' &&
        totalNumberOfOrders > 0 &&
        orderHistoryLoaded && (
          <ExportButton
            orderHistoryRequest={pHRequest}
            setAlertState={setAlertState}
            totalNumberOfOrders={totalNumberOfOrders}
          />
        )}
      {isDesktop &&
        customerType === 'b2b' &&
        totalNumberOfOrders > 0 &&
        orderHistoryLoaded && (
          <PrintButton orderHistory={pHRequest} setAlertState={setAlertState} />
        )}
      {customerType === 'b2b' && (
        <div style={{ maxWidth: 200, padding: 15 }}>
          <AddReceiptButton svocId={svocID} />
        </div>
      )}
    </div>
  );
};
